import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { useSeo } from "@/hooks/useSeo";

export default function AdminDashboard() {
  useSeo({ robots: "noindex,nofollow", title: "Admin Dashboard | Allen Travels RD" });
  const { user, isAdmin, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!user || !isAdmin)) {
      navigate("/admin");
    }
  }, [user, isAdmin, loading, navigate]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
  if (!isAdmin) return null;

  return <AdminLayout />;
}
